import { CLOSE_MODAL, OPEN_MODAL } from 'constants/actions';

const modals = (state = null, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return action.payload;
    case CLOSE_MODAL:
      return null;
    default:
      return state;
  }
};

export default modals;
